/** Images */
import { ReactComponent as Line } from "../../assets/line.svg";

/** MUI */
import {
    Box,
    Container,
    Typography,
    Grid2 as Grid,
} from "@mui/material";

/** Components */
import classes from "./simplebanner.module.css";

const SimpleBanner = (props) => {
    const { title } = props;

    return (
        <Box className={classes.background}>
            <Box className={classes.svgcontainer}>
                <Line />
            </Box>
            <Container maxWidth="xl" disableGutters className={classes.containerBan}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8, xxl: 7 }}>
                        <Box className={classes.textcontainer}>
                            <Typography variant="h1" color="secondary" className={classes.paddingB}>
                                {title}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default SimpleBanner;